import { FC } from "react";

import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { Box, useMediaQuery, useTheme } from "@mui/material";

interface IDesignationInfoSetupFieldsPanel {
	onDesignationSelectionChangeHandler: (value: any) => void;
	designationDDLItems: any
}
export const DesignationInfoSetupFieldsPanel: FC<
	IDesignationInfoSetupFieldsPanel
> = ({ designationDDLItems, onDesignationSelectionChangeHandler }) => {

	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;

	return (
		<Box>
			{mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
				label="Load Designation"
				selectName="designation"
				testId={`designation`}
				labelPosition={LabelPosition.Top}
				items={designationDDLItems ?? []}
				onSelectionChangeHandler={onDesignationSelectionChangeHandler}
				showEmpty
			/>}
			<RHookFormTextFieldWithLabel
				label="Id"
				id="code"
				testId={`code`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormTextFieldWithLabel
				label="Work Title/ Designation"
				id="designationName"
				testId={`Designation`}
				labelPosition={LabelPosition.Top}
			// labelColumns={4}
			// fieldColumns={8}
			// required
			/>
			<EnhancedTextAreaFieldRHF
				label="Notes"
				id="notes"
				testId={`notes`}
				// placeholder="Notes"
				labelPosition={LabelPosition.Top}
			// labelColumns={4}
			// fieldColumns={8}
			/>
		</Box>
	);
};
